import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid, Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// @ts-ignore
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';

// Child Components
// @ts-ignore
import TimesheetDeleteModalButton from './components/TimesheetDeleteModalButton';

interface StateProps {
    isOpen?: boolean;
    id?: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type ComponentProps = StateProps & DispatchProps;

export class TimesheetDeleteModal extends React.PureComponent<ComponentProps> {
    handleClose = (): void => {
        this.props.updateQueryString({
            timesheetDeleteModal: undefined,
            selectedTimesheet: undefined
        });
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;

        if (!id) return null;

        return (
            <Modal
                size="tiny"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="TimesheetDeleteModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Delete Timesheet</Modal.Header>
                    <Modal.Content>
                        <Grid>
                            <Grid.Column>
                                <p>
                                    Are you sure you want to delete this Timesheet?
                                </p>
                            </Grid.Column>
                        </Grid>
                        <ErrorAlert namespace="TIMESHEET_DELETE" />
                        <Grid centered>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <TimesheetDeleteModalButton timesheetId={id} />
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isOpen: makeSelectQueryStringBooleanValue('timesheetDeleteModal'),
    id: makeSelectQueryStringNumberValue('selectedTimesheet')
});

export default connect<StateProps, DispatchProps>(
    mapStateToProps,
    {
        updateQueryString
    }
)(TimesheetDeleteModal);
